import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect, useRef } from 'react';

import Modal from './Modal';

import { PRIMARY_COLOR, RED, HOVER_RED } from '../../appearance/Colors';

import styled from 'styled-components';

function DeleteModal({ title, description, closeButtonText, actionButtonText, isOpen, closeModal, loading = false }) {
    const {t: lnT} = useTranslation();

    const confirmButtonRef = useRef(null);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (!isOpen) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                closeModal(false);
                return;
            }

            if (event.key === 'Enter') {
                event.preventDefault();
                if (loading) {
                    return;
                }
                confirmButtonRef.current?.click();
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isOpen, closeModal, loading]);

    const afterOpenModal = () => {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    };

    const onCloseModal = () => {
        closeModal(undefined);
        // cleanup
    };

    // if (title) {
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={onCloseModal}
            style={deleteModalStyle}
            // className="Modal"
            overlayClassName="Overlay"
            contentLabel={lnT('common:exampleModal')}
        >
            <DialogContent>
                <DialogTitle>{title}</DialogTitle>
                <DialogDescription>{description}</DialogDescription>
                <DialogActions>
                    <ActionButton
                        onClick={e => {
                            e.stopPropagation();
                            closeModal(false);
                        }}
                    >
                        {closeButtonText ? closeButtonText : lnT('common:cancel')}
                    </ActionButton>
                    <DangerTag
                        ref={confirmButtonRef}
                        disabled={loading}
                        onClick={e => {
                            e.stopPropagation();
                            if (loading) {
                                return;
                            }
                            closeModal(true);
                        }}
                    >
                        {actionButtonText ? actionButtonText : lnT('folders:deleteForever')}
                    </DangerTag>
                </DialogActions>
            </DialogContent>
        </Modal>
    );
    // }
    // return null;
}

const deleteModalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        color: 'black',
        maxWidth: 360,
        minWidth: 320,
        border: 'none',
        borderRadius: 18,
        padding: 18,
        backgroundColor: '#f7f7f7'
    }
};

const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
`;

const DialogTitle = styled.div`
    color: ${PRIMARY_COLOR};
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    margin-bottom: 8px;
`;

const DialogDescription = styled.div`
    color: rgba(15, 15, 15, 0.72);
    margin-bottom: 18px;
    font-size: 14px;
    line-height: 1.5;
`;

const DialogActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
`;

const ActionButton = styled.button`
    padding: 10px 14px;
    background-color: rgba(15, 15, 15, 0.08);
    border-radius: 12px;
    color: rgba(15, 15, 15, 0.82);
    font-size: 13px;
    cursor: pointer;
    font-weight: 600;
    border: none;
    user-select: none;
    &:hover {
        background-color: rgba(15, 15, 15, 0.12);
        color: rgba(15, 15, 15, 1);
    }
`;

const DangerTag = styled.button`
    padding: 10px 14px;
    background-color: ${RED};
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.92);
    font-size: 13px;
    cursor: pointer;
    font-weight: 600;
    border: none;
    user-select: none;
    opacity: ${props => props.disabled ? 0.68 : 1};
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    &:hover {
        background-color: ${HOVER_RED};
        color: rgba(255, 255, 255, 1);
    }
`;

export default DeleteModal;
